import { CalendarFilled } from "@ant-design/icons"
import { Card, Descriptions, Table } from "antd"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { getTimeSlotById } from "../../store/slices/timeSlotSlice"

const ViewTimeSlot = () => {
    const { id } = useParams()
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getTimeSlotById(id))
    }, [dispatch, id])
    const { timeSlot } = useSelector((state) => state?.timeSlot)
    console.log(timeSlot)
    return (
        <div>
            <Card
                title={
                    <span style={{ fontSize: '18px', fontWeight: 600 }}>
                        Time Slot Information
                    </span>
                }
                style={{
                    marginBottom: 24,
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    border: 'none',
                }}
            >
                <Descriptions column={{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} bordered>
                    <Descriptions.Item label={<span style={{ color : "black" }}>Day</span>}>
                            {timeSlot?.data?.day}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            <Card
                    title={
                        <span style={{ fontSize: '18px', fontWeight: 600 }}>
                            <CalendarFilled style={{ marginRight: 8, color: '#CA9AE8' }} />
                            Time Slots
                        </span>
                    }
                    style={{
                        marginBottom: 24,
                        borderRadius: '12px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        border: 'none',
                    }}
                >
                    <Table
                        dataSource={timeSlot?.data?.time_slot}
                        rowKey={(item) => item._id}
                        columns={[
                            {
                                title: "Start Time",
                                dataIndex: ["start_time"]
                            },
                            {
                                title: "End Time",
                                dataIndex: ["end_time"]
                            },
                        ]}
                    />
            </Card>
        </div>
    )
}

export default ViewTimeSlot